export default __webpack_public_path__ + "locales/lo-LA/Settings.json?hash=85b205d0827cbf48a8576e09633e450e";